import { useFormikContext } from 'formik';
import React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { groupNameMessage } from '../../../styles/CommonStyles';
import { SiteSettingsForSiteAdminProps } from '../site-settings/ReactSiteSettingsForSiteAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';
import { forceUncheckedIfUserVisibilityLimited, useUserVisibilityLimited } from './UserVisibilitySection';

export const COMMENTING_ENABLED_FIELD = 'settings.siteCommentingSettings.commentingEnabled';
export const COMMENTING_MENTIONS_ENABLED_FIELD = 'settings.siteCommentingSettings.commentingMentionsEnabled';

export type CommentingSettingSectionProps = SiteSettingsForSiteAdminProps< 'siteCommentingSettings' | 'userVisibility'>;

export function CommentingSettingSection(props: CommentingSettingSectionProps) {
  const formik = useFormikContext<CommentingSettingSectionProps>();
  const isCommentingEnabled = props.settings.siteCommentingSettings?.commentingEnabled;
  const commentSettingLabel = FeatureFlags.userNotificationSettingsEnabled ? Messages.commentingMentionsSiteSettingGeneral() : Messages.commentingMentionsSiteSetting();
  // isUserVisibilityLimited calls a hook. Save this value as a variable to keep the rules of hooks preserved
  const userVisibilityLimited = useUserVisibilityLimited();
  return <SettingsSection title={renderTitle(userVisibilityLimited)}
                          testId={'commenting-setting-section'}
                          description={Messages.commentingSiteSettingsDetails()}
                          disabled={userVisibilityLimited}>
            <FormikCheckbox disabled={userVisibilityLimited}
                name={COMMENTING_ENABLED_FIELD}
                label={Messages.commentingSiteSettingsEnable()}
                testId={'commenting-enabled'}
                {...forceUncheckedIfUserVisibilityLimited(userVisibilityLimited)}>
            </FormikCheckbox>
            {FeatureFlags.commentingMentionsEnabled && isCommentingEnabled &&
              <FormikCheckbox name={COMMENTING_MENTIONS_ENABLED_FIELD}
                              label={commentSettingLabel}
                              testId={'commenting-mentions-enabled'}
                              disabled={userVisibilityLimited}
                              {...forceUncheckedIfUserVisibilityLimited(userVisibilityLimited)}
              />
            }
  </SettingsSection>;
}

function renderTitle(isUserVisibilityLimited: boolean) {
  return <>
    <span>{Messages.commentingSiteSettings()}</span>
    {isUserVisibilityLimited &&
      <span className={groupNameMessage} data-tb-test-id={'commenting-uservisibility-warning'}>
        {Messages.userVisibilityWarning()}
    </span>
    }
  </>;
}

export const CommentingSettingSectionSpecs = componentRegistryEntry({
  name: 'CommentingSettingSection',
  component: CommentingSettingSection
});
